import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { StoreSection } from "../../../../redux/services/store/storeCategoryPagesApi";

type Props = {
  section: StoreSection;
};

const CategoryHeroBannerSection: React.FC<Props> = ({ section }) => {
  const settings = section.settings_json || {};
  const items = section.items || [];
  const firstItem = items[0]?.content_json || {};

  const imageUrl =
    settings.image_url ||
    firstItem.image_url ||
    firstItem.image ||
    "";

  const title =
    settings.title ||
    firstItem.title ||
    section.title ||
    "";

  const subtitle =
    settings.subtitle ||
    firstItem.subtitle ||
    "";

  const buttonText =
    settings.button_text ||
    firstItem.button_text ||
    "";

  const buttonLink =
    settings.button_link ||
    firstItem.button_link ||
    firstItem.url ||
    "#";

  if (!imageUrl && !title && !subtitle) return null;

  return (
    <section className="section pb-0 mt-4">
      <Container fluid>
        <div
          className={`position-relative rounded-3 ${settings.wrapper_class || ""}`}
          style={{
            backgroundImage: imageUrl ? `url(${imageUrl})` : undefined,
            backgroundSize: settings.background_size || "cover",
            backgroundPosition: settings.background_position || "center",
            backgroundRepeat: "no-repeat",
            minHeight: settings.min_height || "320px",
          }}
        >
          <Row className={settings.row_class || "justify-content-end"}>
            <Col xxl={settings.col_xxl || 4} xl={settings.col_xl || undefined}>
              <div className={settings.content_class || "text-end py-4 px-5 mx-xxl-5"}>
                {title ? (
                  <h1
                    className={
                      settings.title_class ||
                      "text-white display-5 lh-base text-capitalize ff-secondary mb-3 fst-italic"
                    }
                  >
                    {title}
                  </h1>
                ) : null}

                {subtitle ? (
                  <p className={settings.subtitle_class || "text-white mb-3"}>
                    {subtitle}
                  </p>
                ) : null}

                {buttonText ? (
                  <div>
                    <Link
                      to={buttonLink}
                      className={settings.link_class || "link-effect link-light"}
                    >
                      {buttonText}
                      <i className="ri-arrow-right-line align-bottom ms-1"></i>
                    </Link>
                  </div>
                ) : null}
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default CategoryHeroBannerSection;